import React from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import InfoTooltip from '@components/info-tooltip/info-tooltip.tsx';
import { KpiCardProps } from '@shared/models/charts/kpi-card.model.ts';

const KpiCard: React.FC<KpiCardProps> = ({
  icon,
  arrowIcon,
  title,
  value,
  percent,
  percentTextColor,
  background,
  hideTrend = false,
  infoTooltip
}) => {
  const { t } = useTranslation();

  const isNotAvailable = percent === 'N/A';
  const tooltipTitle = isNotAvailable
    ? t('analytics_percent_not_available_tooltip')
    : undefined;

  return (
    <div
      className="flex flex-col justify-between w-full h-[190.5px] max-w-95.25
      gap-0.5 p-[22px_28px_16px_28px] rounded-[13px] shadow-[0_4px_16px_0_rgba(0,0,0,0.1)] max-lg-xl:h-[159.5px] max-lg-xl:p-[16px_18px_16px_18px]"
      style={{ background }}
    >
      <div className="flex items-center gap-4 w-full min-w-0">
        {icon && (
          <img
            src={icon}
            alt={t(title)}
            className="w-17.5 h-17.5 shrink-0 max-lg-xl:w-15 max-lg-xl:h-15"
          />
        )}
        <div className="min-w-0 flex-1 flex flex-col gap-3 max-lg-xl:gap-2">
          <div className="flex items-center min-w-0">
            <p className="text-[18px] font-semibold text-(--white) leading-snug max-lg-xl:text-[15px]">
              {t(title)}
            </p>
            {infoTooltip && (
              <div className="shrink-0">
                <InfoTooltip text={infoTooltip} color="var(--white)" />
              </div>
            )}
          </div>
          <div className="w-full h-px bg-white/50"></div>
        </div>
      </div>

      <p className="text-[34px] font-semibold text-(--white) leading-normal flex justify-end max-lg-xl:text-[24px]">
        {value}
      </p>

      {!hideTrend ? (
        <div className="flex w-fit items-center gap-1 px-2 py-1 bg-(--white) rounded-[50px]">
          {arrowIcon && <img src={arrowIcon} alt="Icon" />}

          <Tooltip title={tooltipTitle}>
            <span style={{ color: percentTextColor }} className="text-[13px]">
              {percent}
            </span>
          </Tooltip>
        </div>
      ) : null}
    </div>
  );
};

export default KpiCard;
